import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";
import { VENUE } from "@/lib/site";

const rows = [
  { label: "DAY ONE", value: "Friday, November 13, 2026", sub: "11:00 AM — 3:00 PM" },
  { label: "DAY TWO", value: "Saturday, November 14, 2026", sub: "7:00 PM — 10:00 PM" },
  {
    label: "LOCATION",
    value: `${VENUE.name} — ${VENUE.city.split(",")[0]}`,
    sub: `${VENUE.address} // ${VENUE.city}`,
  },
  { label: "ACCESS", value: "wemeetweeat.co", sub: "Official ticketing channel" },
];

export default function Details() {
  return (
    <section data-testid="details-section" className="border-b border-ink/15">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="details-label">Your Official Briefing</SectionLabel>

        <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          <MaskLine>RECON 2026</MaskLine>
          <MaskLine delay={0.1}>
            <span className="font-sans text-lg font-semibold tracking-[0.5em] text-oxblood md:text-xl">
              THE&nbsp;BRIEFING
            </span>
          </MaskLine>
        </h2>

        <div className="mt-16 border-t border-ink/20">
          {rows.map((row, i) => (
            <FadeUp key={row.label} delay={i * 0.07}>
              <div
                data-testid={`details-row-${row.label.toLowerCase().replace(/\s/g, "-")}`}
                className="grid gap-2 border-b border-ink/20 py-8 md:grid-cols-12 md:items-baseline"
              >
                <p className="font-sans text-[11px] tracking-[0.35em] text-ink/50 md:col-span-3">
                  {row.label}
                </p>
                <p
                  className={`font-serif text-2xl tracking-tight md:col-span-5 md:text-3xl ${
                    row.tba ? "italic text-oxblood" : "text-ink"
                  }`}
                >
                  {row.value}
                </p>
                <p className="font-sans text-xs tracking-[0.2em] text-smoke md:col-span-4 md:text-right">
                  {row.sub.toUpperCase()}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.35} className="mt-14">
          <a
            href="/checkout"
            data-testid="details-cta-button"
            className="group relative inline-flex items-center overflow-hidden border border-wine bg-wine px-10 py-5 font-sans text-xs tracking-[0.4em] text-bone"
          >
            <span className="absolute inset-0 translate-y-full bg-navy transition-transform duration-500 ease-out group-hover:translate-y-0" />
            <span className="relative">GET YOUR BRIEFING</span>
            <span className="relative ml-4 inline-block transition-transform duration-300 group-hover:translate-x-1.5">
              →
            </span>
          </a>
        </FadeUp>
      </div>
    </section>
  );
}
